////////////////////////////////////////////////////////////////////////////////
// Copyright 2019 Federated Wireless.
//
// GOVERNMENT PURPOSE RIGHTS
//
// Contractor Name:    Federated Wireless
// Contractor Address: 3865 Wilson Blvd, Arlington, VA 22203
//
// The Government's rights to use, modify, reproduce, release, perform, display,
// or disclose this software are restricted by paragraph (b)(2) of the Rights in
// Noncommercial Computer Software and Noncommercial Computer Software
// Documentation clause contained in the 7013 Clause. Any reproduction of the
// software or portions thereof marked with this legend must also reproduce the
// markings.
// This source code delivery is exclusively for Government Purposes pertaining
// to this program; no commercial use. The Computer Software Configuration
// Items were delivered for only the purposes spelled out by the contract
// delivered under.
//
// Export Warning - The technical data in this document (or file) is
// controlled for export under the International Traffic in Arms Regulations
// (ITAR), 22CFR 120-130.  Violations of these export laws may be subject to
// fines and penalties under the Arms Export Control Act (22 U.S.C. 2778).
//
////////////////////////////////////////////////////////////////////////////////
//
// Security Classification: UNCLASSIFIED
//
////////////////////////////////////////////////////////////////////////////////

import React, { Component } from 'react';
import { Field } from 'redux-form';
import renderField from './renderField'



class TddFormPage extends Component {



  renderError = ({ meta: { touched, error } }) =>
    touched && 
    error ? <span>{error}</span> : false


  render(){

    return (
        <React.Fragment>
        { !this.props.disableCopyOption && <div>
            <label htmlFor={"copylast"+this.props.fieldprexix}>{(this.props.fieldprexix==3)?"Copy licencee name and address":"Copy licencee contact details"}</label>
            <div>
            <Field name={"copylast"+this.props.fieldprexix} id={"copylast"+this.props.fieldprexix} component="input" type="checkbox"/>
            </div>
        </div>}
          <Field
            name={"licenceename"+this.props.fieldprexix}
            type="text"
            component={renderField}
            disabled={this.props.disableFields}
            label="Name"
            placeholder="Enter name"
          />
          {this.props.showTradingName && <Field
            name={"tradingname"+this.props.fieldprexix}
            type="text"
            component={renderField}
            disabled={this.props.disableFields}
            label="Trading Name"
            placeholder="Enter trading name if different from above"
          />}
          <Field
            name={"licenceeaddress"+this.props.fieldprexix}
            type="text"
            component={renderField}
            disabled={this.props.disableFields}
            label="Address"
            placeholder="Enter the address"
          />
          <Field
            name={"licenceepostcode"+this.props.fieldprexix}
            type="text"
            component={renderField}
            disabled={this.props.disableFields}
            label="Postcode"
            placeholder="Enter the postcode"
          />
          <Field
            name={"licenceecountry"+this.props.fieldprexix}
            type="text"
            component={renderField}
            disabled={this.props.disableFields}
            label="Country"
            placeholder="Enter the country"
          />
          <Field
            name={"telephone"+this.props.fieldprexix}
            type="tel"
            component={renderField}
            disabled={this.props.disableFields}
            label="Telephone"
            placeholder="Enter the telephone number"
          />
          <Field
            name={"mobile"+this.props.fieldprexix}
            type="tel"
            component={renderField}
            disabled={this.props.disableFields}
            label="Mobile"
            placeholder={this.props.disableFields ? "" : "Enter the mobile number"}
          />
          <Field
            name={"fax"+this.props.fieldprexix}
            type="tel"
            component={renderField}
            disabled={this.props.disableFields}
            label="Fax"
            placeholder={this.props.disableFields ? "" : "Enter the fax number"}
          />
          <Field
            name={"email"+this.props.fieldprexix}
            type="email"
            component={renderField}
            disabled={this.props.disableFields}
            label="Email"
            placeholder="Email address is required for this tool"
          />
          </React.Fragment>
    );
  };

}

export default TddFormPage



